import { toaster } from '@optiaxiom/react';
import { useMutation, useQueryClient } from '@tanstack/react-query';

import http from '@frontend/api/http';
import { OPAL_URL } from '@frontend/envConfig';
import { CompanionRule, CreateRuleRequest } from '@frontend/types';

export function useAppCompanionRuleCreate(agentId: string, onSuccess?: () => void) {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: async (rule: CreateRuleRequest) => {
      return (
        await http.post<CompanionRule>(
          `${OPAL_URL}/app-companion/api/agents/${agentId}/rules`,
          rule
        )
      ).data;
    },
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: ['opal:app-companion', 'rules', agentId],
      });
      toaster.create('Rule created successfully', { type: 'success' });
      onSuccess?.();
    },
    onError: (error: Error & { response?: { data?: { message?: string } } }) => {
      const errorMessage = error?.response?.data?.message || 'Failed to create rule';
      toaster.create(errorMessage, { type: 'danger' });
    },
  });
}
